
import { AiAnalysisTypes } from '../../Mentions/enums/ai-analysis-types.enum';
import { DropdownOptionModel } from '../models/dropdown-option.model';

export const coverageInsightTypesOptions: DropdownOptionModel[] = [
    new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.EXECUTIVE_SUMMARY}`, AiAnalysisTypes.EXECUTIVE_SUMMARY),
    new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.KEY_TAKEAWAYS}`, AiAnalysisTypes.KEY_TAKEAWAYS),
    new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.BRAND_IMPACT}`, AiAnalysisTypes.BRAND_IMPACT),
    new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.SENTIMENT_OPINION}`, AiAnalysisTypes.SENTIMENT_OPINION),
    new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.TOP_NARRATIVES}`, AiAnalysisTypes.TOP_NARRATIVES),
    new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.CUSTOM}`, AiAnalysisTypes.CUSTOM),
];
